import React, { useState } from 'react'
import {
  Collapse,
  Container,
  Divider,
  Grid,
  makeStyles,
  Typography,
  Toolbar,
  Popper,
  Paper,
} from '@material-ui/core'
import { useTranslate } from 'react-admin'
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import Alert from '@material-ui/lab/Alert'
import appIntegrationStyles from './appIntegration.styles'
import LoaderDots from '../../../components/loaders/LoaderDots/LoaderDots'
import TextButton from '../../../components/ui/TextButton/TextButton'
import ConditionalRender from '../../../components/ConditionalRender/ConditionalRender'

const AppIntegration = (props) => {
  const {
    linkMutation,
    unLinkMutation,
    icon: Icon,
    text,
    infoText,
    linkButton,
    isLoading,
    linkedAccountName,
    configurationForm,
    disabled = false,
    disabledMessage = '', // Add disabledMessage prop
    // Set when the account is still linked but the link no longer works (e.g. YouTube refused
    // the refresh token). The card keeps the account name and Unlink, and offers the link
    // button a second time as a reconnect.
    warningText = null,
  } = props
  const [expandedForm, setExpandedForm] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [showTooltip, setShowTooltip] = useState(false)
  const translate = useTranslate()
  const useStyles = makeStyles(appIntegrationStyles(expandedForm))
  const classes = useStyles()
  let button

  const handleMouseEnter = (event) => {
    if (disabled && disabledMessage) {
      setAnchorEl(event.currentTarget)
      setShowTooltip(true)
    }
  }

  const handleMouseLeave = () => {
    setShowTooltip(false)
  }

  const buttonStyle = disabled
    ? {
        cursor: 'not-allowed',
        opacity: 0.6,
        pointerEvents: 'auto',
      }
    : {
        cursor: 'pointer',
      }

  if (typeof linkButton === 'string') {
    button = (
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <TextButton
          label={linkButton}
          className={classes.button}
          onClick={!disabled ? linkMutation.mutate : undefined}
          disabled={disabled}
        />
      </div>
    )
  } else {
    button = (
      <div
        style={buttonStyle}
        onClick={!disabled ? linkMutation.mutate : undefined}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {linkButton}
      </div>
    )
  }

  const disabledTooltip = (
    <Popper open={showTooltip} anchorEl={anchorEl} placement='bottom' style={{ zIndex: 1500 }}>
      <Paper elevation={3} style={{ marginTop: 8 }}>
        <Toolbar
          variant='dense'
          style={{
            borderRadius: 4,
            minHeight: 48,
          }}
        >
          <Typography variant='body2'>{disabledMessage}</Typography>
        </Toolbar>
      </Paper>
    </Popper>
  )

  return (
    <div>
      <Divider variant='middle' className={classes.divider} />
      <Container className={classes.containerApp}>
        <Grid item xs={12} className={classes.titleContainer}>
          {Icon}
        </Grid>
        <Grid item xs={12} className={classes.textContainer}>
          {text}
        </Grid>
        {isLoading ? (
          <LoaderDots style={{ marginLeft: 10 }} />
        ) : (
          <>
            <ConditionalRender renderValue={!!infoText}>
              <Alert
                variant='outlined'
                severity='info'
                style={{ backgroundColor: '#f4faff' }}
                className={classes.info}
              >
                {infoText}
              </Alert>
            </ConditionalRender>
            <ConditionalRender renderValue={!!warningText}>
              <Alert variant='outlined' severity='warning' className={classes.info}>
                {warningText}
              </Alert>
            </ConditionalRender>
            <div className={classes.integrationFooter}>
              <Grid item xs={11} className={classes.buttonsContainer}>
                {!linkedAccountName ? button : <Typography>{linkedAccountName}</Typography>}
                {linkedAccountName && warningText && !disabled && button}
                {linkedAccountName && (
                  <div
                    onMouseEnter={disabled ? handleMouseEnter : undefined}
                    onMouseLeave={disabled ? handleMouseLeave : undefined}
                  >
                    <TextButton
                      label={translate('ra.text.unlink')}
                      className={classes.button}
                      onClick={!disabled ? unLinkMutation.mutate : undefined}
                      disabled={disabled}
                    />
                  </div>
                )}
              </Grid>
              {linkedAccountName && configurationForm && (
                <Grid
                  item
                  xs={1}
                  className={classes.configuration}
                  onClick={() => !disabled && setExpandedForm((prevState) => !prevState)}
                  style={{
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    opacity: disabled ? 0.6 : 1,
                  }}
                  onMouseEnter={disabled ? handleMouseEnter : undefined}
                  onMouseLeave={disabled ? handleMouseLeave : undefined}
                >
                  <Typography color='primary'>Configuration</Typography>
                  <KeyboardArrowDown className={classes.arrow} />
                </Grid>
              )}
            </div>
          </>
        )}
        {linkedAccountName && configurationForm && (
          <Collapse in={expandedForm} timeout='auto' unmountOnExit>
            {configurationForm}
          </Collapse>
        )}
        {disabledTooltip}
      </Container>
    </div>
  )
}

export default AppIntegration
